export class CreateLogSector {
    constructor(repository) {
        this.repository = repository
    }
    async execute(data) {

        let {
            ID_SECTOR,
            TIME,
            OFFSET
        } = data

        const resp = await this.repository.save(
            ID_SECTOR,
            TIME,
            OFFSET
        )

        return resp
    }
}
